import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroCarousel from '@/components/feature/HeroCarousel';
import SectionHeading from '@/components/base/SectionHeading';
import FilmCard from '@/components/base/FilmCard';
import CategoryShortcuts from './components/CategoryShortcuts';
import NewsList from './components/NewsList';
import PopularRanking from './components/PopularRanking';
import SiteIntro from './components/SiteIntro';
import { films } from '@/mocks/films';
import { sortFilms } from '@/utils/content';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta({
    title: '成人影视-最新成人影视资讯与内容平台',
    description:
      '成人影视网站提供丰富的成人影视资讯、内容介绍及相关影视作品信息，帮助用户了解和查找感兴趣的成人影视内容。',
    keywords: '成人影视,影视资讯,成人电影,成人影视内容,影视推荐,成人影视平台',
  });

  const featured = sortFilms(films, 'rating').slice(0, 8);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroCarousel />

        <section className="page-shell pt-14 md:pt-16">
          <SectionHeading
            eyebrow="Browse by category"
            title="分类快捷入口"
            description="按题材与出品方向组织的六个主要分类，每个分类下还有更细的子分类可供筛选。"
            action={{ to: '/category/drama', label: '从剧情长片开始' }}
          />
          <CategoryShortcuts />
        </section>

        <section className="page-shell pt-14 md:pt-16">
          <div className="grid gap-8 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <SectionHeading
                eyebrow="Latest news"
                title="最新资讯"
                description="新片动态、修复重映、影展片单与幕后记录，按发布时间由近到远排列。"
              />
              <NewsList limit={6} />
            </div>
            <div className="lg:col-span-4">
              <div className="mb-5 flex items-end justify-between">
                <div>
                  <p className="eyebrow mb-2">Popular</p>
                  <h2 className="text-xl font-semibold text-foreground-950 md:text-2xl">热门条目</h2>
                </div>
              </div>
              <PopularRanking />
            </div>
          </div>
        </section>

        <section className="page-shell pt-14 md:pt-16">
          <SectionHeading
            eyebrow="Editor's selection"
            title="精选影视内容"
            description="按条目评分挑选的八部作品，覆盖剧情长片、艺术影像与纪实观察三类方向。"
            action={{ to: '/search', label: '检索全部条目' }}
          />
          <div className="grid grid-cols-2 gap-x-4 gap-y-7 sm:grid-cols-3 lg:grid-cols-4">
            {featured.map((film, index) => (
              <FilmCard key={film.id} film={film} index={index} />
            ))}
          </div>
        </section>

        <section className="page-shell pt-14 md:pt-16">
          <div className="flex flex-col items-start justify-between gap-5 rounded-lg border border-primary-500/25 bg-primary-500/[0.06] p-6 sm:flex-row sm:items-center md:p-8">
            <div>
              <p className="eyebrow mb-2">Search the archive</p>
              <h2 className="text-lg font-semibold text-foreground-950 md:text-xl">记不住片名？直接搜索关键词</h2>
              <p className="mt-2 text-[12px] leading-6 text-foreground-600">
                支持片名、导演、演员、地区与标签的模糊匹配，也可用类型与年份进一步缩小范围。
              </p>
            </div>
            <Link
              to="/search"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-line" />
              进入搜索页
            </Link>
          </div>
        </section>

        <section className="page-shell pt-14 md:pt-16">
          <SiteIntro />
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}